import { render, staticRenderFns } from "./DocumentoList.vue?vue&type=template&id=b3168d32"
import script from "./DocumentoList.vue?vue&type=script&lang=js"
export * from "./DocumentoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports